/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchOperationsMode } from './MatchOperationsMode';
import {
    MatchOperationsModeFromJSON,
    MatchOperationsModeFromJSONTyped,
    MatchOperationsModeToJSON,
    MatchOperationsModeToJSONTyped,
} from './MatchOperationsMode';
import type { TournamentMatchmakingMode } from './TournamentMatchmakingMode';
import {
    TournamentMatchmakingModeFromJSON,
    TournamentMatchmakingModeFromJSONTyped,
    TournamentMatchmakingModeToJSON,
    TournamentMatchmakingModeToJSONTyped,
} from './TournamentMatchmakingMode';
import type { TournamentRegistrationFieldPreference } from './TournamentRegistrationFieldPreference';
import {
    TournamentRegistrationFieldPreferenceFromJSON,
    TournamentRegistrationFieldPreferenceFromJSONTyped,
    TournamentRegistrationFieldPreferenceToJSON,
    TournamentRegistrationFieldPreferenceToJSONTyped,
} from './TournamentRegistrationFieldPreference';

/**
 * 
 * @export
 * @interface TournamentDetail
 */
export interface TournamentDetail {
    /**
     * 
     * @type {string}
     * @memberof TournamentDetail
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetail
     */
    tournamentId?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetail
     */
    infoHtml?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetail
     */
    locationUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetail
     */
    infoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetail
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetail
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetail
     */
    city?: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetail
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetail
     */
    longitude?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentDetail
     */
    isInvitationOnly?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TournamentDetail
     */
    invitedEmails?: Array<string>;
    /**
     * 
     * @type {Array<TournamentRegistrationFieldPreference>}
     * @memberof TournamentDetail
     */
    registrationFieldPreferences?: Array<TournamentRegistrationFieldPreference>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TournamentDetail
     */
    allowedCountries?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentDetail
     */
    hasTermsAndConditions?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetail
     */
    termsAndConditionsFileName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentDetail
     */
    allowPaymentReceiptUpload?: boolean;
    /**
     * 
     * @type {TournamentMatchmakingMode}
     * @memberof TournamentDetail
     */
    matchmakingMode?: TournamentMatchmakingMode;
    /**
     * 
     * @type {MatchOperationsMode}
     * @memberof TournamentDetail
     */
    matchOperationsMode?: MatchOperationsMode;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetail
     */
    matchOperationsRulesetCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentDetail
     */
    publicLiveFeedEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentDetail
     */
    overlayFeedEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetail
     */
    overlayThemeCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentDetail
     */
    showTeamsTab?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentDetail
     */
    showScheduleTab?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentDetail
     */
    showResultsTab?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentDetail
     */
    showStructureTab?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentDetail
     */
    showClassificationTab?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetail
     */
    tournamentStatus?: string;
}



/**
 * Check if a given object implements the TournamentDetail interface.
 */
export function instanceOfTournamentDetail(value: object): value is TournamentDetail {
    return true;
}

export function TournamentDetailFromJSON(json: any): TournamentDetail {
    return TournamentDetailFromJSONTyped(json, false);
}

export function TournamentDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tournamentId': json['tournamentId'] == null ? undefined : json['tournamentId'],
        'infoHtml': json['infoHtml'] == null ? undefined : json['infoHtml'],
        'locationUrl': json['locationUrl'] == null ? undefined : json['locationUrl'],
        'infoUrl': json['infoUrl'] == null ? undefined : json['infoUrl'],
        'country': json['country'] == null ? undefined : json['country'],
        'state': json['state'] == null ? undefined : json['state'],
        'city': json['city'] == null ? undefined : json['city'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'isInvitationOnly': json['isInvitationOnly'] == null ? undefined : json['isInvitationOnly'],
        'invitedEmails': json['invitedEmails'] == null ? undefined : json['invitedEmails'],
        'registrationFieldPreferences': json['registrationFieldPreferences'] == null ? undefined : ((json['registrationFieldPreferences'] as Array<any>).map(TournamentRegistrationFieldPreferenceFromJSON)),
        'allowedCountries': json['allowedCountries'] == null ? undefined : json['allowedCountries'],
        'hasTermsAndConditions': json['hasTermsAndConditions'] == null ? undefined : json['hasTermsAndConditions'],
        'termsAndConditionsFileName': json['termsAndConditionsFileName'] == null ? undefined : json['termsAndConditionsFileName'],
        'allowPaymentReceiptUpload': json['allowPaymentReceiptUpload'] == null ? undefined : json['allowPaymentReceiptUpload'],
        'matchmakingMode': json['matchmakingMode'] == null ? undefined : TournamentMatchmakingModeFromJSON(json['matchmakingMode']),
        'matchOperationsMode': json['matchOperationsMode'] == null ? undefined : MatchOperationsModeFromJSON(json['matchOperationsMode']),
        'matchOperationsRulesetCode': json['matchOperationsRulesetCode'] == null ? undefined : json['matchOperationsRulesetCode'],
        'publicLiveFeedEnabled': json['publicLiveFeedEnabled'] == null ? undefined : json['publicLiveFeedEnabled'],
        'overlayFeedEnabled': json['overlayFeedEnabled'] == null ? undefined : json['overlayFeedEnabled'],
        'overlayThemeCode': json['overlayThemeCode'] == null ? undefined : json['overlayThemeCode'],
        'showTeamsTab': json['showTeamsTab'] == null ? undefined : json['showTeamsTab'],
        'showScheduleTab': json['showScheduleTab'] == null ? undefined : json['showScheduleTab'],
        'showResultsTab': json['showResultsTab'] == null ? undefined : json['showResultsTab'],
        'showStructureTab': json['showStructureTab'] == null ? undefined : json['showStructureTab'],
        'showClassificationTab': json['showClassificationTab'] == null ? undefined : json['showClassificationTab'],
        'tournamentStatus': json['tournamentStatus'] == null ? undefined : json['tournamentStatus'],
    };
}

export function TournamentDetailToJSON(json: any): TournamentDetail {
    return TournamentDetailToJSONTyped(json, false);
}

export function TournamentDetailToJSONTyped(value?: TournamentDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tournamentId': value['tournamentId'],
        'infoHtml': value['infoHtml'],
        'locationUrl': value['locationUrl'],
        'infoUrl': value['infoUrl'],
        'country': value['country'],
        'state': value['state'],
        'city': value['city'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'isInvitationOnly': value['isInvitationOnly'],
        'invitedEmails': value['invitedEmails'],
        'registrationFieldPreferences': value['registrationFieldPreferences'] == null ? undefined : ((value['registrationFieldPreferences'] as Array<any>).map(TournamentRegistrationFieldPreferenceToJSON)),
        'allowedCountries': value['allowedCountries'],
        'hasTermsAndConditions': value['hasTermsAndConditions'],
        'termsAndConditionsFileName': value['termsAndConditionsFileName'],
        'allowPaymentReceiptUpload': value['allowPaymentReceiptUpload'],
        'matchmakingMode': TournamentMatchmakingModeToJSON(value['matchmakingMode']),
        'matchOperationsMode': MatchOperationsModeToJSON(value['matchOperationsMode']),
        'matchOperationsRulesetCode': value['matchOperationsRulesetCode'],
        'publicLiveFeedEnabled': value['publicLiveFeedEnabled'],
        'overlayFeedEnabled': value['overlayFeedEnabled'],
        'overlayThemeCode': value['overlayThemeCode'],
        'showTeamsTab': value['showTeamsTab'],
        'showScheduleTab': value['showScheduleTab'],
        'showResultsTab': value['showResultsTab'],
        'showStructureTab': value['showStructureTab'],
        'showClassificationTab': value['showClassificationTab'],
        'tournamentStatus': value['tournamentStatus'],
    };
}

